
import Component from 'vue-class-component';
import moment from 'moment';
import commentReply from './commentReply';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';
import { IPSService } from '@/services/ipsServices';
import style from '@/views/components/linkForm/style.vue';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component({
    mixins: [style],
})
export default class CommentList extends IPSDialog {
    title = '期刊评论';

    width = '1150px';

    cancelText = '关闭'

    confirm = false

    commentList: ItemArray<QiKanCommentInfo> = [];

    saleNumberLoading = false;

    selected = [];

    page = 1

    pageSize = 10

    totalCount = 0

    keyword = ''

    qiKanId = 0

    siteList = []

    key = 0

    mounted() {
        this.getCommentsList()
    }
    /**
   * 获取留言列表(API)
   * @return null
   */
    public getCommentsList(): void {
        const postParams = {
            siteCodes: this.siteList,
            keyword: this.keyword,
            qiKanId: this.qiKanId,
            page: this.page,
            pageSize: this.pageSize,
        };
        this.saleNumberLoading = true
        IPSService.getCommentList({ postParams }).then((res) => {
            this.totalCount = res.count;
            this.commentList
                = res.list && res.list.length
                    ? res.list.map((i: any) => {
                        i.createTime = moment(i.createTime).format('YYYY-MM-DD HH:mm:ss');
                        return i;
                    })
                    : [];
            this.key = Math.random()
            this.saleNumberLoading = false
            this.$forceUpdate()
        }).catch((error) => {
            this.saleNumberLoading = false
        }), () => {
            this.saleNumberLoading = false
        };
    }


    // 点击回复
    openComment(val) {
        commentReply.open({ value: val }).then(async (res) => {
            this.saleNumberLoading = true;
            res['siteId'] = val.siteId
            IPSService.commentSave({ postParams: res }).then((result) => {
                if (result) {
                    this.$message.success('回复成功！')
                    this.getCommentsList()
                }
            })

        })
    }
    /**
   * 留言批量操作：0-隐藏 1-显示
   * @param {number} type
   * @return null
   */
    public batchComments(type: number): void {
        if (!this.selected.length) {
            return
        }
        const commentIdList = this.selected.map(item => item.commentId)
        const postParams = {
            qiKanId: this.qiKanId,
            commentIdList,
            state: type,
        };
        this.updateCommentsState(postParams);
    }

    /**
     * 隐藏/显示 操作
     * @param id
     * @param type
     * @return null
     */
    public updateComment(id, type): void {
        const postParams = {
            qiKanId: this.qiKanId,
            commentIdList: [id],
            state: type,
        };
        this.updateCommentsState(postParams);
    }
    /**
       * 改变留言的状态 api
       * @param postParams
       * @return null
       */
    public updateCommentsState(postParams): void {
        IPSService.updateCommentStatus({ postParams }).then((responseData) => {
            if (responseData.ret) {
                this.$message.success('操作成功');
                this.page = 1;
                this.getCommentsList();
            } else {
                this.$message.error('操作失败');
            }
        });
    }

    onSizeChange(val) {
        this.page = 1;
        this.pageSize = val;
        this.getCommentsList();
    }

    onPageChange(val) {
        this.page = val;
        this.getCommentsList();
    }
    /**
* 当前输入的留言关键字
* @return null
*/
    public getCommentWord(e?) {
        if (e && e.keyCode !== 13) {
            return;
        }
        this.page = 1
        this.getCommentsList();
    }
    renderContent(h) {
        return (
            <div class="select-list">
                <div class="filterController">
                    <div class="inputWrapper wid-180">
                        <el-input v-model={this.keyword} placeholder="评论人/手机号" nativeOn-keyup={(e) => { this.getCommentWord(e) }} />
                        <i class="iconfont iconsousuo" onClick={() => { this.getCommentWord() }} />
                    </div>
                </div>

                <div class="tableWrapper width-100">
                    <el-table
                        key={this.key}
                        data={this.commentList}
                        height="450px"
                        tooltip-effect="light"
                        v-loading={this.saleNumberLoading}
                        on-selection-change={(v) => {
                            this.selected = v;
                        }}>
                        <el-table-column type="selection" width="55" />
                        <el-table-column type="index" label="ID" width="55" align="center" />
                        <el-table-column prop="commentContent" width="300" label="评论内容" show-overflow-tooltip {...{
                            scopedSlots: {
                                default: (scope) => {
                                    return (
                                        <div>
                                            {scope.row.replyBuyerName ? <span>【回复{scope.row.replyBuyerName}】{scope.row.commentContent
                                            }</span> : <span>{scope.row.commentContent}</span>}
                                        </div>
                                    );
                                },
                            },
                        }} />
                        <el-table-column prop="buyerName" label="评论人" show-overflow-tooltip {...{                           
                        scopedSlots: {
                                default: (scope) => {
                                    return (
                                        <span v-encrypt={{ data: scope.row.buyerName, type: 'name' }}> {scope.row.buyerName} </span>
                                    );
                                },
                            },
                        }} />
                        <el-table-column prop="buyerPhone" width="160" label="手机号" show-overflow-tooltip {...{
                            scopedSlots: {
                                default: (scope) => {
                                    return (
                                        <span v-encrypt={{ data: scope.row.buyerPhone, type: 'phone' }}> {scope.row.buyerPhone} </span>
                                    );
                                },
                            },
                        }} />
                        <el-table-column prop="createTime" label="评论时间" width="160" />
                        <el-table-column
                            prop="siteCode"
                            width="80"
                            label="评论状态"
                            show-overflow-tooltip
                            {...{
                                scopedSlots: {
                                    default: (scope) => {
                                        return (
                                            <div>
                                                {scope.row.isShow == 1 && <span>可见</span>}
                                                {scope.row.isShow == 0 && <span>隐藏</span>}
                                            </div>
                                        );
                                    },
                                },
                            }}
                        />

                        <el-table-column
                            prop=""
                            width="140"
                            label="操作"
                            align="center"
                            {...{
                                scopedSlots: {
                                    default: (scope) => {
                                        return (
                                            <div>
                                                {scope.row.buyerId !== -1 && <span class="scopeSpan" onClick={() => this.openComment(scope.row)}>回复</span>}
                                                {scope.row.isShow == 1 && <span class="scopeSpan" onClick={() => this.updateComment(scope.row.commentId, 0)}>设为隐藏</span>}
                                                {scope.row.isShow == 0 && <span class="scopeSpan" onClick={() => this.updateComment(scope.row.commentId, 1)}>设为可见</span>}

                                            </div>
                                        );
                                    },
                                },
                            }}
                        />
                    </el-table>
                </div>
                <div class="bottomWrapper">
                    <div class="fl">
                        <el-button type="primary" size='medium' disabled={!this.selected.length} onClick={() => this.batchComments(1)}>
                            批量设为可见
                        </el-button>
                        <span class={['scopeSpan r-ml-14', !this.selected.length && 'disabled']} onClick={() => this.batchComments(0)}>
                            批量设为隐藏
                        </span>
                    </div>
                    <div>
                        <el-pagination
                            class='relative-position'
                            on-size-change={val => this.onSizeChange(val)}
                            on-current-change={val => this.onPageChange(val)}
                            current-page={this.page}
                            page-sizes={[10, 15, 20, 30]}
                            page-size={this.pageSize}
                            layout="total, sizes, prev, pager, next, jumper"
                            total={this.totalCount}></el-pagination>
                    </div>
                </div>
            </div>
        );
    }
}
